import { cancelReasonOptionMessages } from '../Appointments.messages';

const BOOKABLE_TYPES = {
  PRACTITIONER: 'PRACTITIONER',
  RESOURCE: 'RESOURCE',
};

export const PARTNER_CANCEL_REASON = {
  PRACTITIONER_DOUBLE_BOOKED_NO_OTHER_AVAILABLE: 'PRACTITIONER_DOUBLE_BOOKED_NO_OTHER_AVAILABLE',
  PRACTITIONER_DOUBLE_BOOKED_NEED_TO_ASSIGN_OTHER: 'PRACTITIONER_DOUBLE_BOOKED_NEED_TO_ASSIGN_OTHER',
  PRACTITIONER_UNAVAILABLE_AT_THIS_TIME: 'PRACTITIONER_UNAVAILABLE_AT_THIS_TIME',
  PRACTITIONER_MAX_RESERVATIONS_NUMBER_REACHED: 'PRACTITIONER_MAX_RESERVATIONS_NUMBER_REACHED',
  DIRECT_BOOKING_WITH_HIGHER_PRIORITY: 'DIRECT_BOOKING_WITH_HIGHER_PRIORITY',
  SERVICE_SHOULD_NOT_BE_ON_CLASSPASS: 'SERVICE_SHOULD_NOT_BE_ON_CLASSPASS',
  SERVICE_IS_NO_LONGER_OFFERED: 'SERVICE_IS_NO_LONGER_OFFERED',
  LOCATION_CLOSED: 'LOCATION_CLOSED',
  OTHER: 'OTHER',
};

export const PARTNER_CANCEL_REASON_MESSAGES = {
  [PARTNER_CANCEL_REASON.PRACTITIONER_DOUBLE_BOOKED_NO_OTHER_AVAILABLE]:
    cancelReasonOptionMessages.doubleBookedNoOtherAvailable,
  [PARTNER_CANCEL_REASON.PRACTITIONER_DOUBLE_BOOKED_NEED_TO_ASSIGN_OTHER]:
    cancelReasonOptionMessages.doubleBookedNeedToAssignOther,
  [PARTNER_CANCEL_REASON.PRACTITIONER_UNAVAILABLE_AT_THIS_TIME]:
    cancelReasonOptionMessages.practitionerUnavailableAtThisTime,
  [PARTNER_CANCEL_REASON.PRACTITIONER_MAX_RESERVATIONS_NUMBER_REACHED]:
    cancelReasonOptionMessages.practitionerMaxReservationsNumberReached,
  [PARTNER_CANCEL_REASON.DIRECT_BOOKING_WITH_HIGHER_PRIORITY]:
    cancelReasonOptionMessages.directBookingWithHigherPriority,
  [PARTNER_CANCEL_REASON.SERVICE_SHOULD_NOT_BE_ON_CLASSPASS]: cancelReasonOptionMessages.serviceShouldNotBeOnClassPass,
  [PARTNER_CANCEL_REASON.SERVICE_IS_NO_LONGER_OFFERED]: cancelReasonOptionMessages.serviceNoLongerAvailable,
  [PARTNER_CANCEL_REASON.LOCATION_CLOSED]: cancelReasonOptionMessages.locationClosed,
  [PARTNER_CANCEL_REASON.OTHER]: cancelReasonOptionMessages.other,
};

export const CONCIERGE_CANCEL_REASONS = {
  NO_AVAILABILITY_SAT: 'NO_AVAILABILITY_SAT',
  NO_AVAILABILITY_NO_AT: 'NO_AVAILABILITY_NO_AT',
  NO_POTP: 'NO_POTP',
  VENUE_UNREACHABLE: 'VENUE_UNREACHABLE',
  DONT_WANT_TO_PREPAY: 'DONT_WANT_TO_PREPAY',
  DOES_NOT_WANT_TO_BE_PART_OF_CP: 'DOES_NOT_WANT_TO_BE_PART_OF_CP',
  ONLINE_BOOKING_ONLY: 'ONLINE_BOOKING_ONLY',
  VENUE_CLOSED_TEMP_PERMANENT: 'VENUE_CLOSED_TEMP_PERMANENT',
};

export const TIME_BLOCK_ELIGIBLE_REASONS = [
  PARTNER_CANCEL_REASON.PRACTITIONER_DOUBLE_BOOKED_NO_OTHER_AVAILABLE,
  PARTNER_CANCEL_REASON.PRACTITIONER_DOUBLE_BOOKED_NEED_TO_ASSIGN_OTHER,
  PARTNER_CANCEL_REASON.PRACTITIONER_UNAVAILABLE_AT_THIS_TIME,
  PARTNER_CANCEL_REASON.PRACTITIONER_MAX_RESERVATIONS_NUMBER_REACHED,
  PARTNER_CANCEL_REASON.DIRECT_BOOKING_WITH_HIGHER_PRIORITY,
];

export const ALTERNATIVE_TIME_ELIGIBLE_BOOKABLE_TYPES = [BOOKABLE_TYPES.PRACTITIONER];

export const ALTERNATIVE_TIME_ELIGIBLE_REASONS = [
  CONCIERGE_CANCEL_REASONS.NO_AVAILABILITY_SAT,
  PARTNER_CANCEL_REASON.PRACTITIONER_DOUBLE_BOOKED_NO_OTHER_AVAILABLE,
  PARTNER_CANCEL_REASON.PRACTITIONER_DOUBLE_BOOKED_NEED_TO_ASSIGN_OTHER,
  PARTNER_CANCEL_REASON.PRACTITIONER_UNAVAILABLE_AT_THIS_TIME,
  PARTNER_CANCEL_REASON.PRACTITIONER_MAX_RESERVATIONS_NUMBER_REACHED,
  PARTNER_CANCEL_REASON.DIRECT_BOOKING_WITH_HIGHER_PRIORITY,
];
